import {combineReducers} from "redux";

import chat from './reducers/chat';
//import forumsStats from "./reducers/forumsStats";
import {forumsStats} from "./creators/forums.stats";

import {album} from './creators/album';
import {albumMedia} from "./creators/album.media";
import {albumMedias} from './creators/album.medias';
import {albumMediasMulti} from './creators/album.medias-multi';

import {articles} from './creators/articles';
import {article} from './creators/article';
import {articlesTag} from "./creators/articles.tag";
import {articleComment} from './creators/article.comment';
import {articleComments} from './creators/article.comments';

import {bestTagArticle} from "./creators/bestTagArticle";

import {videoCategories} from './creators/videoCategories';

import {commentsModeration} from './creators/user.comments.moderation';
import {mediaCommentsModeration} from './creators/user.comments.moderation.media';
import {articleCommentsModeration} from './creators/user.comments.moderation.article';
import {commentsToModerate} from './creators/user.comments.to-moderate';
import {commentToModerate} from './creators/user.comment.to-moderate';

import {clickCta} from './creators/clickCta';
import {currentUser} from './creators/currentUser';
import {currentUserQuestions} from './creators/currentUser.questions';

import {datingTopics} from './creators/dating.topics';

import {forums} from './creators/forums';
import {forumLastTopics} from './creators/forum.last.topics';
import {forumsListMove} from './creators/forums.listMove';
import {forumCategories} from "./creators/forums.categories";
import {forumChildrens} from './creators/forums.children';
import {forumBreadcrumbs} from './creators/forums.breadcrumbs';
import {forumTopic} from './creators/forums.topic';
import {forumTopics} from './creators/forums.topics';
import {forumTopicFollow} from './creators/forum.topic.follow';
import {forumComment} from './creators/forums.comment';
import {forumComments} from './creators/forums.comments';

import {homeMediaCreator} from './creators/home.medias.creator';
import {homeMediaAll} from './creators/home.medias.all';
import {homeMediaTopVideos} from './creators/home.medias.topvideos';
import {homeLastArticles} from './creators/home.lastArticles';
import {homeLastStatus} from './creators/home.lastStatus';
import {homeLastTopics} from './creators/home.lastTopics';
import {homeFollowProfiles} from './creators/home.followProfiles';
import {homeStories} from './creators/home.stories';

import {like} from "./creators/like";
import {commentLike} from './creators/comment.like';
import {likes} from "./creators/likes";

import {locationCountries} from './creators/locations.countries';
import {locationRegions} from './creators/locations.regions';
import {locationCounties} from './creators/locations.counties';
import {locationCities} from './creators/locations.cities';

import {locationRegionsFR} from './creators/locations.regionsFR';

import {meetUsers} from './creators/meet.users';

import {media} from './creators/media';
import {mediaComment} from './creators/media.comment';
import {mediaComments} from './creators/media.comments';

import {medias} from './creators/medias';

import {mediaviewerMedia} from './creators/mediaviewer.media';

import {offers} from './creators/offers';

import {reporting} from "./creators/reporting";
import {reportings} from "./creators/reportings";
import {reportingComment} from "./creators/reporting.comment";
import {reportingComments} from "./creators/reporting.comments";
import {report} from "./creators/report";

import {room} from './creators/room';
import {roomMessages} from './creators/room.messages';
import {roomMedias} from './creators/room.medias';
import {roomMessage} from './creators/room.message';
import {rooms} from './creators/rooms';

import {signup} from './creators/signup';

import {statusComment} from './creators/user.status.comment';
import {statusComments} from './creators/user.status.comments';

import {stories} from './creators/stories';
import {story} from './creators/story';
import {storiesTag} from './creators/stories.tag'

import {subComment} from './creators/comments.subComment';
import {subComments} from "./creators/comments.subComments";

import {survey} from './creators/survey';

import {tagsProtagonist} from './creators/tagsProtagonist';
import {tagsWarning} from './creators/tagsWarning';
import {tagsStories} from './creators/stories.tagsStories';
import {tagsMedia} from "./creators/tagsMedia";
import {tagsBlog} from "./creators/tagsBlog";
import {tags} from "./creators/tags";
import {tag} from './creators/tag';
import {mediasTag} from './creators/medias.tag';

import {timelineComment} from './creators/timeline.comment';
import {timelineComments} from './creators/timeline.comments';

import {user} from './creators/user';
import {userAlbum} from './creators/user.album';
import {userAlbums} from './creators/user.albums';
import {userArticles} from './creators/user.articles';
import {userEmail} from "./creators/user.email";
import {userFollowers} from './creators/user.followers';
import {userFollowing} from './creators/user.following';
import {userFollowings} from './creators/user.followings';
import {userFriend} from './creators/user.friend';
import {userFriends} from './creators/user.friends';
import {userFriendsSidebar} from "./creators/user.friends.sidebar";
import {userFriendRequest} from './creators/user.friendRequest';
import {userFriendsRequest} from './creators/user.friendsRequest';
import {userLastVisitors} from './creators/user.last-visitors';
import {userMedias} from "./creators/user.medias";
import {userPassword} from "./creators/user.password";
import {userQuestion} from './creators/user.question';
import {userQuestions} from './creators/user.questions';
import {userRandomQuestions} from "./creators/users.randomQuestions";
import {userNotifications} from './creators/user.notifications';
import {userUnreadNotifications} from './creators/user.unreadNotification';
import {userStatus} from './creators/user.status';
import {userTimelines} from './creators/user.timelines';
import {usersIgnored} from './creators/user.usersIgnored';
import {userIgnored} from './creators/user.userIgnored';
import {userTopPhotos} from './creators/user.top.photos';
import {userTopVideos} from './creators/user.top.videos';
import {userWarnings} from './creators/user.warnings';
import {userWarning} from "./creators/user.warning";
import {userUnreadRooms} from "./creators/user.unreadRooms";
import {usersOnline} from "./creators/users.online";
import {userForgotPassword} from "./creators/user.forgotPassword";
import {userConfirmEmail} from "./creators/user.confirmEmail";
import {userConfirmAccount} from "./creators/user.confirmAccount";

import {users} from './creators/users';

import {warning} from './creators/warning';

import login from './reducers2/login';
import rules from './reducers2/rules';
import {categoriesRoot} from "./creators/categories.rootChildrens";
import {categoryRoot} from "./creators/category.rootChildrens";
import {categorizedMedias} from "./creators/categorized.medias";
import {facette} from "./creators/facette";
import {facetteSuggestion} from "./creators/facette.suggestion";
import {requestSuppressionAccount} from "./creators/user.requestSuppression";
import {currentUserAbo} from "./creators/currentUser.abo";
import {currentUserAlbums} from "./creators/currentUser.albums";
import {userByIp} from "./creators/user.findIp";
import {categoriesModeTinder} from "./creators/tagModerations.categoriesModeTinder";
import {categoriesModeList} from "./creators/tagModerations.categoriesModeList";
import {qualificationMedias} from "./creators/tagModerations.qualidifcation.medias";
import {category} from "./creators/category";
import {categoriesModeVideo} from "./creators/tagModerations.categoriesModeVideo";
import {tagModerationQualificationWarningLevel} from "./creators/tagModerationQualificationWarning";
import {verificationMedias} from "./creators/tagModeration.verification.medias";
import {userSessions} from "./creators/user.sessions";
import {isTool} from "./creators/isTool";



/////////
export default combineReducers({
    forumsStats,
    chat,

    login,
    rules,

    isTool,


    album,
    albumMedia,
    albumMedias,
    albumMediasMulti,

    articles,

    article,
    articlesTag,
    articleComments,
    articleComment,

    bestTagArticle,

    category,
    categoryRoot,
    categoriesRoot,

    commentsModeration,
    commentsToModerate,
    commentToModerate,
    mediaCommentsModeration,
    articleCommentsModeration,

    categoriesModeTinder,
    categoriesModeList,
    categoriesModeVideo,
    qualificationMedias,

    verificationMedias,

    clickCta,
    currentUser,
    currentUserQuestions,
    currentUserAbo,
    currentUserAlbums,

    videoCategories,

    datingTopics,

    facette,
    facetteSuggestion,

    forums,
    forumLastTopics,
    forumsListMove,
    forumCategories,
    forumChildrens,
    forumBreadcrumbs,
    forumTopics,
    forumTopic,
    forumTopicFollow,
    forumComments,
    forumComment,

    homeMediaCreator,
    homeMediaAll,
    homeMediaTopVideos,
    homeLastArticles,
    homeLastStatus,
    homeLastTopics,
    homeFollowProfiles,
    homeStories,

    like,
    commentLike,
    likes,

    locationCountries,
    locationRegions,
    locationCounties,
    locationCities,

    locationRegionsFR,

    meetUsers,

    media,
    mediaComment,
    mediaComments,

    medias,
    mediasTag,
    mediaviewerMedia,

    categorizedMedias,

    offers,

    reporting,
    reportings,
    reportingComment,
    reportingComments,
    report,

    requestSuppressionAccount,

    room,
    roomMessages,
    roomMedias,
    roomMessage,
    rooms,

    signup,

    statusComment,
    statusComments,

    stories,
    story,
    storiesTag,

    subComment,
    subComments,

    survey,

    tag,
    tags,
    tagsProtagonist,
    tagsWarning,
    tagsStories,
    tagsMedia,
    tagsBlog,

    tagModerationQualificationWarningLevel,

    timelineComment,
    timelineComments,

    user,
    userAlbum,
    userAlbums,
    userArticles,
    userEmail,
    userFollowers,
    userFollowing,
    userFollowings,
    userFriend,
    userFriends,
    userFriendsSidebar,
    userFriendRequest,
    userFriendsRequest,
    userLastVisitors,
    userMedias,
    userPassword,
    userQuestion,
    userQuestions,
    userRandomQuestions,
    userNotifications,
    userUnreadNotifications,
    userSessions,
    userStatus,
    userTimelines,
    userTopPhotos,
    userTopVideos,
    userIgnored,
    usersIgnored,
    userWarnings,
    userWarning,
    userForgotPassword,
    userConfirmEmail,
    userConfirmAccount,

    users,

    usersOnline,

    userByIp,

    warning,
    userUnreadRooms
    // echo: echoReducer
});

